import { forwardRef } from 'react';
import { Typography } from '../typography';
import { Props } from './types';
import { levelPresets } from './model';

export const Layout = forwardRef<HTMLElement, Props>(function Component(
  { Component = 'span', level = 1, normalize = true, ...props },
  forwardedRef
) {
  return (
    <Typography
      {...props}
      Component={Component}
      baseClassName={levelPresets[level]}
      normalize={normalize}
      ref={forwardedRef}
    />
  );
});
